import { JObject } from "../../../../common/data/models";
import { buildFilterMetaToObject, buildSortParamsToString, PaginatedRequestParams, PaginatedResponse, Result } from "../../../../common/pagination";
import { endpoints } from "../../../../constants/endpoints";
import { tawreedHttpService } from "../../../../http";
import { PaymentOrder } from "../../domain";
import { PaymentordernMapper } from "../mappers";

export class PaymentOrderRepository {

    public search(request: PaginatedRequestParams): Promise<PaginatedResponse<PaymentOrder>> {

        const params = {
            sort: request.sort ? buildSortParamsToString(request.sort) : undefined,
            page: request.page,
            size: request.size,
        };
        const data = { ...buildFilterMetaToObject(request.keyword, { ...request.filters }) };
        return tawreedHttpService.post<JObject, Result<JObject>>(endpoints.PAYMENT_ORDERS_SEARCH, data, params, undefined, 'error')
            .then(res => {
                return {
                    ...res!,
                    data: { ...res!.data!, content: res!.data!.content.map(e => PaymentordernMapper.fromJson(e)) ?? [] },
                };
            });
    }


    /**
     * Get partner details by id
     * @param id
     */
    public async getDetails(id: number): Promise<PaymentOrder> {
        return tawreedHttpService.post<number, JObject>(endpoints.PAYMENT_ORDERS_GET_DETAILS, id, undefined, undefined, 'error').then(res => PaymentordernMapper.fromJson(res.data!));
    }

    public releaseAmount(id: number, otp: string): Promise<boolean> {
        return tawreedHttpService.post<JObject, boolean>(endpoints.PAYMENT_ORDERS_RELEASE_AMOUNT, {
            orderId: id,
            otp: otp
        },undefined,undefined,'all').then(res => {
            return res.status === 200
        });
    }
    public cancel(id: number): Promise<boolean> {
        return tawreedHttpService.post<number, boolean>(endpoints.PAYMENT_ORDERS_CANCEL, id,undefined,undefined,'all').then(res => {
            return res.status === 200
        });
    }
}